import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';

import store from 'tricks/browser/agent/sessionStorage.js';
import {languages, formatLanguageCode} from 'i18n/options';
import changeUserLanguage from 'utils/i18n/changeLanguage';

import Box from 'components/Box';
import {Select, Option} from 'components/Select';
import VisuallyHidden from 'components/VisuallyHidden';

const PERSIST_USER_LANG_KEY = 'shouldPersistLanguageOnLogin';

function enableShouldPersistUserLang() {
	store.setItem(PERSIST_USER_LANG_KEY, true);
}

export function shouldPersistUserLang() {
	return store.getItem(PERSIST_USER_LANG_KEY);
}

function LanguageSwitcher() {
	const [t, i18n] = useTranslation();
	const [userLanguage, setUserLanguage] = useState(
		formatLanguageCode(i18n.language)
	);

	useEffect(() => {
		changeUserLanguage(userLanguage);
	}, [userLanguage]);

	function changeLanguage(newLanguage) {
		setUserLanguage(newLanguage);
		enableShouldPersistUserLang();
	}

	return (
		<Box position="absolute" top="xs" right="xxs" z="raised">
			<VisuallyHidden as="label" id="auth_language_title">
				{t('profile_choose_language')}
			</VisuallyHidden>
			<Select
				id="auth_language_dropdown"
				labelledById="auth_language_title"
				value={userLanguage}
				onChange={changeLanguage}
				size="medium"
				variant="transparent"
				icon="globe"
			>
				{languages.map(lang => (
					<Option key={lang.value} value={lang.value}>
						{lang.title}
					</Option>
				))}
			</Select>
		</Box>
	);
}

export default LanguageSwitcher;
